import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayCode } from "../models/DelayCode";

export const getDelayCodes = async (
	params: { assetId: number | null },
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "DelayAreaAssetId", value: params.assetId },
	];

	const resp = await apiService.callV2(
		"[DEL].[GetDelayCodes]",
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayCode[];
	} else {
		throw new Error(resp.message || "Error fetching delay codes");
	}
};
